import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHomeassistantcommunitystoreComponent } from './simple-icons-homeassistantcommunitystore.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHomeassistantcommunitystoreComponent ],
    exports:      [ SimpleIconsHomeassistantcommunitystoreComponent ],
    bootstrap:    []
})
export class SimpleIconsHomeassistantcommunitystoreModule {}
